import React from 'react'
import withFormContext from 'core/components/validatedForm/withFormContext'
import ListTable from 'core/components/listTable/ListTable'
import { ValidatedFormProps } from './model'

interface SearchFunctionProps {
  property: string
}

interface Props extends ValidatedFormProps {
  value?: string[]
  hasError?: boolean
  errorMessage?: string
  onChange?: any
  multiSelection?: boolean
  useToggleSwitch?: boolean
  columns?: any
  data: any
  title?: string
  extraToolbarContent?: JSX.Element
  checkboxCond?: any
  loading: boolean
  uniqueIdentifier?: string
  onReload?: any
  searchTargets?: string[]
  orderBy?: string
  dataTestId?: string
  emptyText?: string
  noScroll?: boolean
  showCheckboxes?: boolean
  noRowsPerPage?: boolean
  checkboxCondMessage?: string
  visibleColumns?: any
  columnsOrder?: any
}

export default withFormContext<any[], Props>(function(props) {
  const {
    onChange,
    value = [],
    hasError,
    errorMessage,
    multiSelection = false,
    useToggleSwitch = false,
    columns,
    data,
    title,
    extraToolbarContent,
    checkboxCond,
    loading,
    uniqueIdentifier,
    onReload,
    searchTargets = ['name'],
    orderBy,
    dataTestId,
    emptyText,
    noScroll,
    showCheckboxes = true,
    noRowsPerPage, // Useful in modals, the row selection causes modals to close
    checkboxCondMessage = '',
    visibleColumns,
    columnsOrder,
    id,
  } = props

  return (
    <>
      <ListTable
        onSelectedRowsChange={onChange}
        title={title}
        columns={columns}
        data={data}
        multiSelection={multiSelection}
        useToggleSwitch={useToggleSwitch}
        selectedRows={value}
        extraToolbarContent={extraToolbarContent}
        checkboxCond={checkboxCond}
        loading={loading}
        uniqueIdentifier={uniqueIdentifier}
        onReload={onReload}
        searchTargets={searchTargets}
        orderBy={orderBy}
        dataTestId={dataTestId}
        emptyText={emptyText}
        noScroll={noScroll}
        showCheckboxes={showCheckboxes}
        noRowsPerPage={noRowsPerPage}
        checkboxCondMessage={checkboxCondMessage}
        errorMessage={hasError ? errorMessage : undefined}
        visibleColumns={visibleColumns}
        columnsOrder={columnsOrder}
        id={`${id}-field`}
      />
    </>
  )
})
